import { render } from "./AddWorkOrder.vue?vue&type=template&id=0aed892f"
import script from "./AddWorkOrder.vue?vue&type=script&lang=js"
export * from "./AddWorkOrder.vue?vue&type=script&lang=js"
script.render = render

export default script